module.exports = __webpack_public_path__ + "static/media/MeSmiling.98568810.png";